module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/chisiamo/chisiamo.component.scss
// module id = ./src/app/chisiamo/chisiamo.component.scss
// module chunks = main